<template>
  <v-app class="a-app">
    <template v-if="token">
      <router-view></router-view>
    </template>
    <template v-else>
      <TheAccessDenied></TheAccessDenied>
    </template>
  </v-app>
</template>

<script>
import { useRoute } from "@/composables/router";
import { useUserState } from "./composables/api/user";

import TheAccessDenied from "./components/App/TheAccessDenied.vue";
import { useI18n } from "./composables/i18n";

export default {
  components: { TheAccessDenied },

  setup() {
    const { locale } = useI18n();
    const { token } = useUserState();
    const route = useRoute();

    locale.value = navigator.language.split("-")[0];

    if (process.env.VUE_APP_DEV_TOKEN) {
      token.value = process.env.VUE_APP_DEV_TOKEN;
    } else {
      token.value = route.value.query.access_token;
    }

    return {
      token
    };
  }
};
</script>

<style lang="scss" src="@/scss/app.scss"></style>
